import { render, staticRenderFns } from "./pbi-ev-tech-report.page.vue?vue&type=template&id=708c4ad9"
import script from "./pbi-ev-tech-report.page.vue?vue&type=script&lang=ts"
export * from "./pbi-ev-tech-report.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports